<!-- eslint-disable max-len -->
<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.1638 18.1638C29.1638 13.1099 25.0539 9 20 9C14.9462 9 10.8362 13.1099 10.8362 18.1638C10.8362 21.3425 12.4646 24.1489 14.9287 25.7944C13.7941 27.046 13.1532 28.6786 13.1532 30.3894C13.1532 30.7272 13.426 31 13.7638 31H26.2361C26.5739 31 26.8467 30.7272 26.8467 30.3894C26.8467 28.6831 26.2057 27.0504 25.0711 25.7944C27.5352 24.1488 29.1636 21.3468 29.1636 18.1638H29.1638ZM12.0577 18.1638C12.0577 13.7854 15.6219 10.2215 20 10.2215C24.3781 10.2215 27.9423 13.7856 27.9423 18.1638C27.9423 22.5419 24.3781 26.1104 20 26.1104C15.6219 26.1104 12.0577 22.5462 12.0577 18.1638ZM25.5912 29.7784H14.4093C14.5478 28.5139 15.1195 27.3316 16.0203 26.4222C17.2242 27.0025 18.5754 27.3316 19.996 27.3316C21.4207 27.3316 22.7719 27.0068 23.976 26.4222C24.8811 27.3272 25.4528 28.5095 25.5913 29.7784H25.5912Z"
      :fill="pathFill"
    />
    <path
      d="M23.4515 18.1637C23.4515 16.2625 21.9054 14.7122 19.9999 14.7122C18.0988 14.7122 16.5484 16.2582 16.5484 18.1637C16.5484 20.0692 18.0944 21.6152 19.9999 21.6152C21.9011 21.6152 23.4515 20.0692 23.4515 18.1637ZM17.774 18.1637C17.774 16.9338 18.7744 15.9377 20 15.9377C21.2255 15.9377 22.2259 16.9381 22.2259 18.1637C22.2259 19.3893 21.2255 20.3897 20 20.3897C18.7744 20.3897 17.774 19.3936 17.774 18.1637Z"
      :fill="pathFill"
    />
    <path
      d="M20 13.3872C20.3378 13.3872 20.6106 13.1143 20.6106 12.7765V12.0576C20.6106 11.7199 20.3378 11.447 20 11.447C19.6622 11.447 19.3893 11.7199 19.3893 12.0576V12.7765C19.3893 13.1143 19.6622 13.3872 20 13.3872Z"
      :fill="pathFill"
    />
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
